import React from 'react';

export const NotificacionesListConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['rh', 'rh_not_signer', 'director', 'funcionario'],
    routes  : [
        {
            path     : '/notificaciones-list',
            component: React.lazy(() => import('./NotificacionesList'))
        }
    ]
};